import styled from "styled-components";
import { SIDEBAR_W } from "../../config/layout";

export const Layout = styled.div`
  display: flex;
  min-height: 100vh;
  background: #e8f2f7;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
`;

export const Main = styled.main`
  margin-left: ${SIDEBAR_W};
  flex: 1;
  display: flex;
  flex-direction: column;
  min-width: 0;
`;

/* Completa hacia la derecha la banda blanca del logo de la sidebar */
export const TopBar = styled.header`
  height: 68px;
  flex-shrink: 0;
  background: #fff;
  border-bottom: 1px solid #e0e8f0;
`;

export const Content = styled.div`
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
  padding: 28px 32px;
`;

export const PageTitle = styled.h1`
  color: #1b3a6b;
  font-size: 1.6rem;
  font-weight: 700;
  margin: 0 0 20px;
`;

export const Columns = styled.div`
  flex: 1;
  min-height: 0;
  display: grid;
  grid-template-columns: minmax(0, 1fr) 320px;
  gap: 24px;
  align-items: start;

  @media (max-width: 1100px) {
    grid-template-columns: minmax(0, 1fr);
  }
`;

/* Ambas columnas comparten alto para que terminen a la misma altura */
const COLUMN_HEIGHT = "calc(100vh - 68px - 140px)";

export const ChatColumn = styled.div`
  min-width: 0;
  height: ${COLUMN_HEIGHT};
  min-height: 420px;
`;

export const DetailsCard = styled.aside`
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 1px 6px rgba(0, 0, 0, 0.07);
  padding: 22px;
`;

export const DetailsTitle = styled.h2`
  color: #1b3a6b;
  font-size: 1.05rem;
  font-weight: 700;
  margin: 0 0 18px;
`;

export const PatientRow = styled.div`
  display: flex;
  align-items: center;
  gap: 14px;
  margin-bottom: 18px;
`;

export const PatientAvatar = styled.img`
  width: 52px;
  height: 52px;
  border-radius: 50%;
  object-fit: cover;
  flex-shrink: 0;
`;

export const PatientCode = styled.span`
  color: #1b2b3a;
  font-size: 0.95rem;
  font-weight: 600;
`;

/* Mensaje fijo para el paciente, dentro de la tarjeta de detalles */
export const MessageLabel = styled.p`
  margin: 16px 0 6px;
  font-size: 0.85rem;
  color: #55606b;
`;

export const MessageBox = styled.div`
  background: #f1f2f4;
  border-radius: 6px;
  padding: 12px 14px;
  font-size: 0.82rem;
  line-height: 1.5;
  color: #333;
  white-space: pre-wrap;
  word-break: break-word;
  max-height: 120px;
  overflow-y: auto;
`;

export const MessageEmpty = styled(MessageBox)`
  color: #9aa7b2;
  font-style: italic;
`;

export const EditMessageRow = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-top: 12px;
`;

export const EditMessageButton = styled.button`
  padding: 8px 18px;
  border-radius: 6px;
  border: none;
  background: #1b6b78;
  color: #fff;
  font-size: 0.82rem;
  cursor: pointer;

  &:hover { background: #175a65; }
`;

export const SideColumn = styled.div`
  display: flex;
  flex-direction: column;
  gap: 18px;
  min-width: 0;
  height: ${COLUMN_HEIGHT};
  min-height: 420px;
`;

export const SectionTitle = styled.h2`
  color: #1b3a6b;
  font-size: 1.05rem;
  font-weight: 700;
  margin: 0 0 10px;
`;

export const ScheduleButton = styled.button`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 11px 16px;
  border-radius: 8px;
  border: 1.5px solid #26A9B6;
  background: #fff;
  color: #1b3a6b;
  font-size: 0.85rem;
  font-weight: 600;
  cursor: pointer;

  &:hover { background: #f0fbfc; }
`;

export const DetailLine = styled.p`
  margin: 0 0 6px;
  font-size: 0.85rem;
  color: #333;
  line-height: 1.45;

  strong { font-weight: 700; }
`;
